const euEcommEnabled = [
  'en-GB', 'de-DE', 'en-DE', 
  'fr-FR', 'en-FR', 'it-IT', 
  'en-IT', 'es-ES' , 'en-ES' 
];

// contentfulLocale is the value returned from getContentfulLocale().
export const excludeFromLocale = (contentfulLocale: string, exclusionArray: string[] = []) => {
  if (exclusionArray.includes('EU non-eComm')) {
    // Contentful locale is not an accurate representation of locale at the moment,
    // because a majority of the locales are not configured and would throw a request error.
    // For example, for "en-FR" we simply pass "en-US" to Contentful to get English content.
    const modalEntry = document.getElementById('basic-modal-entry');
    const locale = modalEntry?.dataset.locale;
    // For this specific case, we need to look at a more accurate representation of locale.
    // The following should give us values like "en-FR", "fr-FR", and "fr-BE", which allow
    // us to properly exclude this content based on the values in the comparison array.
    if (locale && !euEcommEnabled.includes(locale)) {
      return true;
    }
  } else if (exclusionArray.includes('EU eComm-enabled')) {
    // The opposite of the above – hide for eComm enabled locales in the EU.
    const modalEntry = document.getElementById('basic-modal-entry');
    const locale = modalEntry?.dataset.locale;
    if (locale && euEcommEnabled.includes(locale)) {
      return true;
    }
  } else {
    // For the majority of cases, just simply exclude if the locale is in the exclusion array.
    return exclusionArray.includes(contentfulLocale);
  }

  return false;
}